import { render } from "./RangePicker.vue?vue&type=template&id=bcef2620&scoped=true"
import script from "./RangePicker.vue?vue&type=script&lang=ts"
export * from "./RangePicker.vue?vue&type=script&lang=ts"

import "./RangePicker.vue?vue&type=style&index=0&id=bcef2620&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-bcef2620"

export default script